import {
  Box,
  Text,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Tab,
} from '@chakra-ui/react'
import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import i18next from 'i18next'
import {useTranslation} from 'react-i18next'

import {useRails} from '~/react/contexts/rails'
import {NextScreenHeader as ScreenHeader} from '~/react/components/ScreenHeader'

import PayBillsTab from './PayBillsTab'
import PaymentActivityTab from './PaymentActivityTab'
import Alerts from './Alerts'
import AccountingProviderSyncTag from '../../components/AccountingProviderSyncTag'
import {usePermissions} from '../../hooks/usePermissions'

export const SupplierBillScreen = ({selectedTab}) => {
  const {
    currentSupplier: {
      id: supplierId,
      accountingProvider: {name: providerName},
      verificationStatus,
    },
  } = useRails()

  const {data: permissionsData, isLoading: isPermissionsLoading} =
    usePermissions()

  i18next.loadNamespaces('pointsOnPayments')
  const {t} = useTranslation()

  const selectedTabIndex = useMemo(() => {
    if (selectedTab === 'paidBills') {
      return 1
    }

    return 0
  }, [selectedTab])

  return (
    <>
      <ScreenHeader text={t('pointsOnPayments:bill.title')}>
        <AccountingProviderSyncTag />
      </ScreenHeader>

      {!isPermissionsLoading && (
        <Alerts
          verificationStatus={verificationStatus}
          completedOnboarding={permissionsData.completedOnboarding}
          supplierId={supplierId}
          accountingProviderName={providerName}
        />
      )}

      <Box p="md" borderRadius="lg" background="mld.neutral.0" flex="auto">
        <Tabs isLazy defaultIndex={selectedTabIndex}>
          <TabList className="fs-unmask" mb="sm" border="0">
            <Tab key="paybills" px={0} mr={2}>
              <Text fontSize="sm" fontWeight="medium" textTransform="uppercase">
                {t('pointsOnPayments:bill.tabs.payBills.title')}
              </Text>
            </Tab>
            <Tab key="paidbills" px={0} ml={2}>
              <Text fontSize="sm" fontWeight="medium" textTransform="uppercase">
                {t('pointsOnPayments:bill.tabs.paymentActivity.title')}
              </Text>
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel key="payBills" p="0">
              <PayBillsTab
                supplierId={supplierId}
                providerName={providerName}
              />
            </TabPanel>
            <TabPanel key="paidBills" p="0">
              <PaymentActivityTab supplierId={supplierId} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </>
  )
}

SupplierBillScreen.propTypes = {
  selectedTab: PropTypes.string.isRequired,
}

export default SupplierBillScreen
